import { call, put, takeLatest } from "redux-saga/effects";
import { axiosInstance, updatedAccessToken } from "../api";
import {
  ERROR,
  GET_CUSTOMER_SUGGESTION_SUCCESS,
  GET_CUSTOMER_SUGGESTION,
  LOADER,
  TOKEN_EXPIRED,
} from "../actions/types";

function getcustomerSuggestionApi(action) {
  let apiUrl1 = `reportsearch?searchStr=${action.payload.searchText}&pagenumber=${action.payload.page}&tab=${action.payload.tab}&order=${action.payload.order}&columnname=${action.payload.columnname}&is_archive=${action.payload.is_archive}&report_id=${action.payload.reportId}`;
  return axiosInstance.get(apiUrl1, { headers: updatedAccessToken() });
}

function* customerSuggestionApi(action) {
  try {
    const response = yield call(() => getcustomerSuggestionApi(action));
    if (response?.data?.statusCode === 200) {
      yield put({
        type: GET_CUSTOMER_SUGGESTION_SUCCESS,
        response: response.data,
      });
    } else {
      yield put({
        type: LOADER,
        payload: false,
      });
      yield put({
        type: ERROR,
        payload: response.data.body.message,
      });
    }
  } catch (err) {
    if (err.response?.status === 403) {
      yield put({
        type: TOKEN_EXPIRED,
        payload: true,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      yield put({
        type: ERROR,
        payload: err.message,
      });
    }
    yield put({
      type: LOADER,
      payload: false,
    });
  }
}

function* customerSuggestion() {
  yield takeLatest(GET_CUSTOMER_SUGGESTION, customerSuggestionApi);
}

const customerSuggestionSaga = {
  customerSuggestion: customerSuggestion(),
};

export default customerSuggestionSaga;
